/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import * as React from 'react';

import { IEcommJobDetailsViewProps } from './ecomm-job-details';

/**
 *
 * EcommContentTemplate1View component
 * @extends {React.PureComponent<IEcommJobDetailsViewProps>}
 */
export class EcommJobDetailsView extends React.PureComponent<IEcommJobDetailsViewProps> {
    public render(): JSX.Element | null {
        const { intro, description, requirements } = this.props;

        return (
            <div className='row ecomm-job-details'>
                <div className='row'>
                    <h4 className='col-sm-8 ecomm-job-details-title'>{this.props.config.title}</h4>
                    {this._renderSocialMedia()}
                    <p className='col-sm-8 ecomm-job-details-intro' id={this.props.id} {...this.props.renderModuleAttributes(this.props)}>
                        {intro}
                    </p>
                </div>
                <div className='col-sm-6'>
                    <h4 className='ecomm-job-details-title sub'>{this.props.config.descriptionTitle}</h4>
                    <p className='ecomm-job-details-text' id={this.props.id} {...this.props.renderModuleAttributes(this.props)}>
                        {description}
                    </p>
                </div>
                <div className='col-sm-6'>
                    <h4 className='ecomm-job-details-title sub'>{this.props.config.reqTitle}</h4>
                    <p className='ecomm-job-details-text' id={this.props.id} {...this.props.renderModuleAttributes(this.props)}>
                        {requirements}
                    </p>
                </div>
            </div>
        );
    }

    private _renderSocialMedia(): JSX.Element | undefined {
        if (!this.props.slots || !this.props.slots.socialShare || this.props.slots.socialShare.length === 0) {
            return undefined;
        }

        return <div className='col-sm-4 ecomm-job-details-social'>{this.props.slots.socialShare}</div>;
    }
}

export default EcommJobDetailsView;
